import { Disclosure } from "@headlessui/react";
import { CaretUp } from "@phosphor-icons/react";
import clsx from "clsx";
import Typography from "./Typography";

export type CollapsibleSectionProps = {
    title: string;
    children: React.ReactNode;
};

const CollapsibleSection = ({ title, children }: CollapsibleSectionProps) => {
    return (
        <Disclosure>
            {({ open }) => (
                <div>
                    <Disclosure.Button
                        className={clsx(
                            "flex bg-surface-light-1 border-surface-light-5 border-1 rounded-xl p-6 pt-5 w-full justify-between focus:outline-none focus-visible:ring focus-visible:ring-black focus-visible:ring-opacity-75",
                            open && "rounded-b-none border-b-0"
                        )}
                    >
                        <Typography component="h2" variant="title-large">
                            {title}
                        </Typography>
                        <CaretUp
                            className={clsx(
                                "h-5 w-5",
                                open && "rotate-180 transform"
                            )}
                        />
                    </Disclosure.Button>
                    <Disclosure.Panel
                        className={clsx(
                            "p-6 bg-surface-light-1 border-surface-light-5 border-1 rounded-xl",
                            open && "rounded-t-none border-t-0"
                        )}
                    >
                        {children}
                    </Disclosure.Panel>
                </div>
            )}
        </Disclosure>
    );
};

export default CollapsibleSection;
